import { render } from "./VabenePosClientManager.vue?vue&type=template&id=0f1e3246&scoped=true&ts=true"
import script from "./VabenePosClientManager.vue?vue&type=script&lang=ts"
export * from "./VabenePosClientManager.vue?vue&type=script&lang=ts"

import "./VabenePosClientManager.vue?vue&type=style&index=0&id=0f1e3246&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1e3246"]])

export default __exports__